<app-mcl-headermenu></app-mcl-headermenu>

<app-notifications #dialog></app-notifications>
<app-invoicelist-dialog #invoicelistDialog></app-invoicelist-dialog>
<div kendoDialogContainer></div>
